import findKey from 'lodash/findKey'
import { PARSE_CONFIG as CONFIGS_LIST} from "@/storage/config/profileConfig";

const ERROR_LIST = {
    "default": 'Неизвестная ошибка',
    "ERROR.GESV" : 'Превышен ГЭСВ',
    "error.security.identity.exists": '',
    "error.field.empty": 'Поле не должно быть пустым',
    "error.field.pattern.mismatch": 'Поле не соотвествует маске ввода',
    "error.same.phone": 'Ошибка error.same.phone',
    "error.wrong.amount": 'Ошибка error.wrong.amount',
    "error.wrong.date.past": 'Ошибка error.wrong.date.past',
    "error.wrong.date.future": 'Ошибка error.wrong.date.future',
    "error.21-63yo": 'Возраст должен быть не менее 21 года и не более 63 лет'
};

function getErrorMessage(errorName) {
    if(typeof ERROR_LIST[errorName] === 'undefined'){
        return ERROR_LIST['default'];
    }else{
        return ERROR_LIST[errorName];
    }
}

function parseConfig(fieldError) {
    return  findKey(CONFIGS_LIST,  function(o) {return o === fieldError; });
}

export default {
    parseConfig,
    getErrorMessage
}

